export * from './ProductDetails'

export type { ProductDetailsProps } from './ProductDetails.types'
